<template lang="pug">
  main
    NavBar
    Loader(v-show="isLoading")
    section.section
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h3.title Visitas&nbsp
              a.button.is-black.is-rounded(v-show="isAdmin" @click="backPage")
                i.fas.fa-times
        .columns.is-mobile.has-text-centered
          //- .column.is-3
          //-   .card
          //-     .card-content
          //-       div.container-card
          //-         div.container-card-logo
          //-           figure.image.is-128x128
          //-             img(src="../../assets/Adenergy2.png")
          //-         br
          //-         a.button.is-dark.is-rounded(@click="registrarEmpleado(1)") Entrar
          //- .column.is-3
          //-   .card
          //-     .card-content
          //-       div.container-card
          //-         div.container-card-logo
          //-           figure.image.is-128x128
          //-             img(src="../../assets/ducter_2.png")
          //-         br
          //-         a.button.is-dark.is-rounded(@click="registrarEmpleado(0)") Entrar
          //- .column.is-3
          //-   .card
          //-     .card-content
          //-       div.container-card
          //-         div.container-card-logo
          //-           figure.image.is-128x128
          //-             img(src="../../assets/financiera_NIETO2.png")
          //-         a.button.is-dark.is-rounded(@click="registrarEmpleado(2)") Entrar
          .column
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-clipboard-list.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Externo
                br
                a.button.is-dark.is-rounded(@click="registrarEmpleado(3)") Entrar
      .columns.column-blanco
</template>

<script>
  import NavBar from './layout/NavBar'
  import Loader from '@/components/shared/Loader.vue'
  import { mapState } from 'vuex'

  export default {
    name: 'HomeAsistencia',
    components: { NavBar, Loader },
    data() {
      return {
        isLoading: false,
        isAdmin: false,
      }
    },
    methods: {
      iniciarComponente() {
        if (this.userLogin.cargo === '000') {
          this.isAdmin = true
        }
      },
      registrarEmpleado (comp) {
        console.log(comp)
        this.$store.commit('origenCorpoVisita', comp)
        this.$router.push('/Visitas/Corpo/Nuevo')
      },

      backPage() {
        this.$router.back()
      },
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
    ...mapState(['logueado', 'userLogin'])
  },
  }
</script>

<style lang="scss" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
  .container-card {
    display: flex;
    flex-direction: column;
    align-content: center;
  }
  .container-card-logo {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/visitas_Componentes/HomeVisitas.vue